import { useState, useEffect, useRef, useMemo, memo, useCallback } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  IconButton,
  Menu,
  MenuItem,
  InputBase,
  ButtonBase,
  Switch,
  Badge,
  Typography,
  FormControlLabel,
} from '@material-ui/core';
import _ from 'lodash';
import * as Yup from 'yup';
import { Group, FormatColorFill, Edit } from '@material-ui/icons';
import {
  MoreIcon,
  DeleteIcon,
  OutstandingIcon,
  ReNameIcon,
  SetHeightIcon,
  AddIcon,
  BedStatusIcon,
} from '../../../../components/Icon';
import Dialog from '../../../../components/Dialog';
import { AutoCompleteSelect } from '../../../../components';
import AutoCompleteCheckbox from '../../../../components/AutoCompleteCheckbox';
import { i18n } from '../../../../language';
import { dutyAssignAPI, systemAPI } from '../../../../apis';
import { classNames } from '../../../../utils';
import { decodeQuery } from '../../../../utils/url';
import AutoCompleteInput from '../../../../components/AutoCompleteInput';
import ColorSelecter from '../ColorSelecter/colorSelecter';
import { LEAD } from '../../../../comm/constant';
import { getCurrentLanguage } from '../../../../utils/languageDetector';
import { functionFunc } from './constant';
import OnDutyCard from './OnDutyCard';
import TeamDetails from './TeamDetailsPopup';
import AreaStaffSelecter from './areaStaffSelecter';
import BedStatusSetting from './BedStatusSetting';

function formatArray(arr, chunkSize = 1) {
  const rets = [];
  for (let i = 0; i < arr.length; i += chunkSize) {
    rets.push(arr.slice(i, i + chunkSize).join(' , '));
  }
  return rets.join('\n');
}

const useStyles = makeStyles((theme) => ({
  rootOnduty: {
    width: '17.188rem',
    padding: '1.313rem 0.938rem 1.25rem',
    borderRadius: '0.9375rem',
    boxShadow: '0 0 0.5rem 0 rgba(125, 134, 169, 0.2)',
    backgroundColor: theme.palette.font.white,
    position: 'relative',
    overflow: 'hidden',
    '&::before': {
      position: 'absolute',
      top: '0',
      left: '0',
      content: '""',
      display: 'block',
      width: '17.25rem',
      height: '0.188rem',
      backgroundColor: theme.palette.primary.main,
      zIndex: '9',
    },
  },
  rootLeave: {
    width: '17.188rem',
    padding: '1.313rem 0.938rem 1.25rem',
    borderRadius: '0.9375rem',
    boxShadow: '0 0 0.5rem 0 rgba(125, 134, 169, 0.2)',
    backgroundColor: theme.palette.font.white,
    position: 'relative',
    overflow: 'hidden',
    '&::before': {
      position: 'absolute',
      top: '0',
      left: '0',
      content: '""',
      display: 'block',
      width: '17.25rem',
      height: '0.188rem',
      backgroundColor: theme.palette.font.sub,
      zIndex: '9',
    },
  },
  head: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '0.938rem',
  },
  filledRule: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.75rem',
    letterSpacing: '0.22px',
    fontWeight: 500,
    color: theme.palette.primary.main,
    textAlign: 'center',
    width: '5.25rem',
    border: '1px solid #538fff',
    borderRadius: '5px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    padding: 2,
    marginRight: 4,
  },
  title: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1.125rem',
    letterSpacing: '0',
    color: theme.palette.font.main,
    fontWeight: '600',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  iconBox: {
    width: '1.5rem',
    height: '1.5rem',
    borderRadius: '0',
    '&::before': {
      content: '""',
      position: 'absolute',
      width: '200%',
      height: '100%',
    },
    '&:hover': {
      backgroundColor: theme.palette.font.white,
    },
  },
  icon: {
    fontSize: '1.125rem',
    color: '#c0c6cb',
  },
  body: {
    '&>div': {
      marginBottom: '0.625rem',
    },
    '&>div:last-child': {
      marginBottom: '0',
    },
  },
  menu: {
    boxShadow: '0 0 1rem 0 rgba(125, 134, 169, 0.2)',
    borderRadius: '0.16875rem',
    '& .MuiList-root': {
      '&>li:first-child': {
        border: '0',
      },
    },
    '& .MuiPopover-paper': {
      overflow: 'none',
      '&::before': {
        position: 'absolute',
        top: '-0.688rem',
        left: '50%',
        marginLeft: '-0.8rem',
        content: '""',
        display: 'block',
        borderBottom: '0.688rem solid #fff',
        borderLeft: '0.688rem solid transparent',
        borderRight: '0.688rem solid transparent',
        width: '1.376rem',
        height: '0.688rem',
        zIndex: '10',
      },
      '&::after': {
        position: 'absolute',
        top: '-0.8rem',
        left: '50%',
        marginLeft: '-0.8rem',
        content: '""',
        display: 'block',
        borderBottom: '0.8rem solid rgba(0,0,0,0.03)',
        borderLeft: '0.8rem solid transparent',
        borderRight: '0.8rem solid transparent',
        width: '1.6rem',
        height: '0.8rem',
        zIndex: '0',
      },
    },
  },
  menuitem: {
    padding: '1.25rem 1rem',
    height: '3.75rem',
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    color: theme.palette.font.main,
    fontWeight: '500',
    borderTop: '0.0625rem solid #e4e7eb',
    '&:hover': {
      backgroundColor: theme.palette.font.white,
    },
  },
  Icon: {
    fontSize: '1.25rem',
    color: '#525e6c',
  },
  dialogTitle: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    color: theme.palette.font.sub,
    fontWeight: '500',
    marginBottom: '0.625rem',
  },
  renameIcon: {
    fontSize: '0.938rem',
    color: '#525e6c',
  },
  iconbox: {
    width: '1.5rem',
    height: '1.5rem',
    marginRight: '1.063rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  addtag: {
    width: '100%',
    height: '3.5rem',
    borderRadius: '0.5rem',
    border: '0.0625rem solid #e4e7eb',
    boxShadow: '-0.0625rem 0.25rem 0.625rem rgba(221, 232, 251, 0.58)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 1rem 0 1.25rem',
  },
  taginput: {
    width: 'auto',
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.919rem',
    fontWeight: '500',
    color: theme.palette.font.sub,
  },
  dropdown: {
    fontSize: '0.875rem',
    color: theme.palette.primary.main,
  },
  tagsItem: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    color: theme.palette.font.main,
    fontWeight: '500',
  },
  tagDropdown: {
    borderRadius: '0',
    width: '1.5rem',
    height: '1.5rem',
    backgroundColor: theme.palette.font.white,
    '&:hover': {
      backgroundColor: theme.palette.font.white,
    },
  },
  deleteContext: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1.25rem',
    lineHeight: '1.875rem',
    color: theme.palette.font.main,
    fontWeight: '500',
    marginBottom: '5.5rem',
  },
  renameInput: {
    width: '100%',
    height: '3.5rem',
    borderRadius: '0.625rem',
    border: '0.0625rem solid #e4e7eb',
    paddingLeft: '1.25rem',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: theme.palette.font.main,
  },
  rulebody: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    marginBottom: '1.875rem',
  },
  ruleitem: {},
  ruleRoot: {
    maxHeight: '23rem',
    overflowY: 'auto',
    marginBottom: '1.188rem',
    '&>div:last-child': {
      marginBottom: '0',
    },
  },
  ruleFoot: {},
  ruleDelete: {
    width: '1.5rem',
    height: '1.5rem',
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    color: theme.palette.font.sub,
    fontWeight: 500,
    marginTop: '2.688rem',
  },
  ruleDeleteIcon: {
    fontSize: '1.25rem',
    color: theme.palette.primary.main,
  },
  ruleAdd: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: theme.palette.primary.main,
    fontWeight: '500',
  },
  ruleIcon: {
    fontSize: '1.438rem',
    marginRight: '0.813rem',
  },
  autoInput: {
    borderColor: '#f44336 !important',
  },
  error: {
    borderColor: '#f44336 !important',
  },
  errorMsg: {
    margin: '3px 0.825rem 0 0.825rem',
    color: '#f44336',
    fontFamily: 'NotoSans-Medium',
    fontWeight: '500',
    marginTop: '0.5rem',
  },
  setHeightTitle: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    color: theme.palette.font.sub,
    fontWeight: 500,
  },
  root: {
    width: '2.85rem',
    height: '1.75rem',
    padding: 0,
  },
  switchBase: {
    '& .MuiSwitch-colorSecondary.Mui-checked': {
      color: '#28d2ab',
    },
    '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track ': {
      backgroundColor: '#28d2ab',
    },
    '& .MuiSwitch-track': {
      backgroundColor: '#4c93ff',
    },
    '& .MuiSwitch-switchBase': {
      color: '#4c93ff',
    },
  },
  thumb: {
    width: '1.2rem',
    height: '1.2rem',
    boxShadow: 'unset',
  },
  track: {
    borderRadius: '1rem',
    background: 'rgba(37, 40, 50, 0.3)',
    opacity: 1,
    // transition: theme.transitions.create(['background-color', 'border']),
  },
  allText: {
    '& .MuiBadge-anchorOriginBottomRightRectangle': {
      right: 0,
      bottom: 0,
      transform: 'scale(1) translate(0%, 60%)',
    },
  },
}));

const checkSubmitData = async (schema, data) => {
  try {
    await schema.validate(data, {
      abortEarly: false,
    });
  } catch (err) {
    const validationErrors = {};
    if (err instanceof Yup.ValidationError) {
      err.inner.forEach((error) => {
        if (error.path !== undefined) {
          validationErrors[error.path] = error.message;
        }
      });
    }
    throw validationErrors;
  }
};

function Delete({ open, setopen, handleDelete, headerTitle, content }) {
  const classes = useStyles();
  return (
    <Dialog
      title={headerTitle ?? i18n.t('DUTYASSIGN_MYTEMPLATE_EDIT_CUBICLE_DELETE')}
      cancel={i18n.t('DUTYASSIGN_CANCEL')}
      confirm={i18n.t('DUTYASSIGN_CONFIRM')}
      cancelID="DutyAssign-Dialog-agw-cancel"
      confirmID="DutyAssign-Dialog-agw-confirm"
      closeID="DutyAssign-Dialog-agw-close"
      open={open}
      handleClose={() => {
        setopen(false);
      }}
      handleCancel={() => {
        setopen(false);
      }}
      handleConfirm={() => {
        handleDelete();
        setopen(false);
      }}
    >
      <div className={classes.deleteContext}>{content ?? i18n.t('DUTYASSIGN_MYTEMPLATE_EDIT_DELETE_CUBICLE_BODY')}</div>
    </Dialog>
  );
}

function AddShift({ open, setopen, allData, updateFunction }) {
  const classes = useStyles();
  const rosterDateOptions = [
    { value: LEAD.TODAY, text: i18n.t('DUTYASSIGN_MYTEMPLATE_EDIT_ROSTER_DATE_OPTION_TODAY') },
    { value: LEAD.YESTERDAY, text: i18n.t('DUTYASSIGN_MYTEMPLATE_EDIT_ROSTER_DATE_OPTION_YESTERDAY') },
    { value: LEAD.TOMORROW, text: i18n.t('DUTYASSIGN_MYTEMPLATE_EDIT_ROSTER_DATE_OPTION_TOMORROW') },
  ];
  const [autoRuleData, setAutoRuleData] = useState([
    {
      srsUnitCode: '',
      srsRankCode: [],
      srsShiftCode: [],
      rosterLeadDay: [rosterDateOptions[0]],
      staffs: [],
      id: 1,
    },
  ]);
  const [wardList, setWardList] = useState([]);
  const [rankList, setRankList] = useState([]);
  const [codeList, setCodeList] = useState([]);
  const [errorMsg, setErrorMsg] = useState({});
  const [unitList, setUnitList] = useState([]);
  const [rosterDateList, setRosterDateList] = useState(rosterDateOptions);
  const refAreaStaffSelecter = useRef();
  const [confirmDisabled, setConfirmDisabled] = useState(true);

  const ruleSchema = {
    srsUnitCode: Yup.string().required(
      i18n.t('DUTYASSIGN_TEMPLATE_AUTORULE_ERROR', { value: i18n.t('DUTYASSIGN_TEMPLATE_WARD') })
    ),
    srsRankCode: Yup.array().min(
      1,
      i18n.t('DUTYASSIGN_TEMPLATE_AUTORULE_ERROR', { value: i18n.t('DUTYASSIGN_TEMPLATE_RANK') })
    ),
    srsShiftCode: Yup.array().min(
      1,
      i18n.t('DUTYASSIGN_TEMPLATE_AUTORULE_ERROR', { value: i18n.t('DUTYASSIGN_TEMPLATE_CODE') })
    ),
    rosterLeadDay: Yup.array().min(
      1,
      i18n.t('DUTYASSIGN_TEMPLATE_AUTORULE_ERROR', { value: i18n.t('BEDSTATUS_DATE') })
    ),
  };

  const focusCheck = (name, id) => {
    return async () => {
      try {
        await checkSubmitData(Yup.object().shape({ [name]: ruleSchema[name] }), {
          [name]: _.find(autoRuleData, (item) => {
            return item.id === id;
          })[name],
        });
        setErrorMsg({ ...errorMsg, [id]: { ...errorMsg[id], [name]: null } });
      } catch (e) {
        setErrorMsg({ ...errorMsg, [id]: { ...errorMsg[id], ...e } });
      }
    };
  };

  const submitCheck = async (id) => {
    try {
      await checkSubmitData(
        Yup.object().shape(ruleSchema),
        _.find(autoRuleData, (item) => {
          return item.id === id;
        })
      );
      setErrorMsg((msg) => {
        return { ...msg, [id]: null };
      });
    } catch (e) {
      setErrorMsg((msg) => {
        return { ...msg, [id]: e };
      });
    }
  };

  const handleInit = () => {
    const data = functionFunc.getShift(allData);
    let tempList = [];
    const handleMap = (props) => {
      return _.map(props.split(','), (item) => {
        return {
          text: item,
          value: item,
        };
      });
    };

    const handleRosterDateMap = (props) => {
      return _.map(props.split(','), (item) => {
        const rosterDate = rosterDateList.find((date) => {
          return date.value.toString() === item;
        });
        return rosterDate;
      });
    };

    if (Array.isArray(data) && data.length > 0) {
      tempList = _.map(data, (item, index) => {
        return {
          ...item,
          srsUnitCode: item.srsUnitCode,
          srsRankCode: handleMap(item.srsRankCode),
          srsShiftCode: handleMap(item.srsShiftCode),
          rosterLeadDay: handleRosterDateMap(item.rosterLeadDay),
          staffs: item.staffs,
          id: index,
        };
      });
    }

    return tempList.length > 0
      ? tempList
      : [
          {
            srsUnitCode: '',
            srsRankCode: [],
            srsShiftCode: [],
            rosterLeadDay: [rosterDateOptions[0]],
            staffs: [],
            id: 1,
          },
        ];
  };

  const getSysHospitalUnitList = async (hospitalCode) => {
    try {
      const { result } = await systemAPI.sysHospitalUnitList({ hospitalCode });
      setUnitList((o) => [...o, ...result]);
    } catch {}
  };

  useEffect(() => {
    setUnitList([]);
    _.forEach(
      _.uniqWith(wardList, (itemA, itemB) => itemA.hospCode === itemB.hospCode),
      (item) => {
        getSysHospitalUnitList(item.hospCode);
      }
    );
  }, [wardList]);

  // get ward API
  const getSrsWardAPI = async () => {
    try {
      const { result } = await dutyAssignAPI.getUnitCode();
      setWardList(result);
    } catch (error) {
      console.log('-----Get SrsWard error----->', error);
    }
  };

  // get rank API
  const getRankListAPI = async () => {
    try {
      const { result } = await dutyAssignAPI.getRankList();
      setRankList(result);
    } catch (error) {
      console.log('-----Get SrsWard error----->', error);
    }
  };

  // get shift code API
  const getCodeAPI = async () => {
    try {
      const { result } = await dutyAssignAPI.getShiftCode();
      setCodeList(result);
    } catch (error) {
      console.log('-----Get SrsWard error----->', error);
    }
  };

  useEffect(() => {
    setAutoRuleData(handleInit());
    (async () => {
      await getSrsWardAPI();
    })();
    (async () => {
      await getRankListAPI();
    })();
    (async () => {
      await getCodeAPI();
    })();

    setRosterDateList(rosterDateOptions);
  }, [allData]);

  const list = useMemo(() => {
    let wardlist = [];
    let ranklist = [];
    let codelist = [];

    if (Array.isArray(wardList) && wardList.length > 0) {
      wardlist = _.map(wardList, (item) => {
        return {
          value: item.wardCode,
          text: _.find(unitList, (unitItem) => unitItem.unitCode === item.wardCode)?.shortDesc ?? '',
        };
      });
    }

    if (Array.isArray(rankList) && rankList.length > 0) {
      ranklist = _.map(rankList, (item) => {
        return {
          value: item,
          text: item,
        };
      });
    }

    if (Array.isArray(codeList) && codeList.length > 0) {
      codelist = _.map(codeList, (item) => {
        return {
          value: item,
          text: item,
        };
      });
    }

    return {
      wardlist: _.orderBy(wardlist, ['text'], ['asc']),
      ranklist: _.orderBy(ranklist, ['text'], ['asc']),
      codelist: _.orderBy(codelist, ['text'], ['asc']),
    };
  }, [wardList, rankList, codeList, unitList]);

  const handleSelect = useCallback(
    ({ id, type }) =>
      (value) => {
        let oldData = autoRuleData;
        const index = _.findIndex(oldData, (item) => item.id === id);
        oldData[index][type] = value;
        setAutoRuleData([...oldData]);
      },
    [autoRuleData]
  );

  const handleAdd = useCallback(() => {
    if (autoRuleData.length === 0) {
      setAutoRuleData([
        {
          srsUnitCode: '',
          srsRankCode: [],
          srsShiftCode: [],
          rosterLeadDay: [rosterDateOptions[0]],
          staffs: [],
          id: 1,
        },
      ]);
    } else {
      let lastId = autoRuleData[autoRuleData.length - 1].id;
      setAutoRuleData([
        ...autoRuleData,
        {
          srsUnitCode: '',
          srsRankCode: [],
          srsShiftCode: [],
          rosterLeadDay: [rosterDateOptions[0]],
          staffs: [],
          id: lastId + 1,
        },
      ]);
    }
  }, [autoRuleData]);

  const handleDelete = useCallback(
    (id) => () => {
      setErrorMsg((err) => {
        return { ...err, [id]: null };
      });
      if (_.filter(autoRuleData, (item) => item.isDeleted !== 1).length > 0) {
        setAutoRuleData((pre) => {
          let temp = pre;
          const tempIndex = _.findIndex(autoRuleData, (item) => {
            return item.id === id;
          });
          if (temp[tempIndex].dutyTemplateMappingId) {
            temp[tempIndex] = {
              ...temp[tempIndex],
              isDeleted: 1,
            };
          } else {
            temp = _.filter(temp, (item) => item.id !== id);
          }
          return temp;
        });
      }
      if (_.filter(autoRuleData, (item) => item.isDeleted !== 1).length === 1) {
        setAutoRuleData((pre) => {
          return [..._.filter(pre, (item) => item.isDeleted === 1)];
        });
      }
    },
    [autoRuleData]
  );

  const errMsg = (id, type) => {
    return errorMsg?.[id] && errorMsg?.[id]?.[type];
  };

  const handleSubmit = () => {
    let data = _.filter(autoRuleData, (item) => {
      return (
        item.isDeleted !== 1 &&
        (item.srsUnitCode.length === 0 ||
          item.srsRankCode.length === 0 ||
          item.srsShiftCode.length === 0 ||
          item.rosterLeadDay.length === 0)
      );
    });

    if (data.length === 0) {
      updateFunction(functionFunc.setFunctionDate(allData, autoRuleData));
      setopen(false);
    }

    data.forEach(async (item) => {
      await submitCheck(item.id);
    });
  };

  useEffect(() => {
    if (errorMsg) {
      const errorKeys = Object.keys(errorMsg);
      const index = errorKeys?.findIndex((key) => {
        if (errorMsg[key]) {
          const subKeys = Object.keys(errorMsg[key]);
          const subIndex = subKeys?.findIndex((subKey) => {
            return errorMsg[key][subKey] !== null;
          });
          return subIndex !== -1;
        } else {
          return false;
        }
      });
      setConfirmDisabled(index !== -1);
    } else {
      setConfirmDisabled(false);
    }
  }, [errorMsg]);

  return (
    <Dialog
      title={i18n.t('DUTYASSIGN_MYTEMPLATE_EDIT_SRS_ADD_RULE_TITLE')}
      cancel={i18n.t('DUTYASSIGN_CANCEL')}
      confirm={i18n.t('DUTYASSIGN_RULE_SAVE')}
      open={open}
      id="DutyAssign-Dialog-agx"
      handleOnClose={() => {
        return;
      }}
      handleClose={() => {
        setopen(false);
      }}
      handleCancel={() => {
        setopen(false);
      }}
      handleConfirm={handleSubmit}
      width={1024}
      disabled={confirmDisabled}
    >
      <div className={classes.ruleRoot}>
        {_.filter(autoRuleData, (item) => item.isDeleted !== 1).map((item, index) => (
          <div className={classes.rulebody} key={item.id}>
            <div className={classes.ruleitem}>
              <div className={classes.dialogTitle}>{i18n.t('DUTYASSIGN_MYTEMPLATE_EDIT_SRS')}</div>
              <AutoCompleteInput
                dropDownIcon={true}
                height="3.5rem"
                width="12rem"
                errMsgMargin="3px 0 0 0.825rem"
                errMsgWidth="11rem"
                placeholder={i18n.t('DUTYASSIGN_MYTEMPLATE_EDIT_SRS_PLACEHOLDER')}
                itemList={list.wardlist}
                value={item.srsUnitCode}
                onChange={handleSelect({ id: item.id, type: 'srsUnitCode' })}
                id={`DutyAssign-AutoCompleteInput-agy-${index}`}
                onOpen={() => {
                  if (list.wardlist.length === 0) {
                    (async () => {
                      await getSrsWardAPI();
                    })();
                  }
                }}
                onBlur={focusCheck('srsUnitCode', item.id)}
                errorMsg={errMsg(item.id, 'srsUnitCode')}
              />
            </div>
            <div className={classes.ruleitem}>
              <div
                className={classes.dialogTitle}
                title={formatArray(
                  item.srsRankCode?.map((el) => el.text),
                  10
                )}
              >
                {i18n.t('DUTYASSIGN_MYTEMPLATE_EDIT_RANK')}
              </div>
              <AutoCompleteCheckbox
                dropDownIcon={true}
                height="3.5rem"
                width="12rem"
                errMsgMargin="3px 0 0 0.825rem"
                errMsgWidth="11rem"
                placeholder={i18n.t('DUTYASSIGN_MYTEMPLATE_EDIT_RANK_PLACEHOLDER')}
                allText="All Rank"
                itemList={list.ranklist}
                value={item.srsRankCode}
                onChange={handleSelect({ id: item.id, type: 'srsRankCode' })}
                id={`DutyAssign-AutoCompleteCheckbox-agz-${index}`}
                onOpen={() => {
                  if (list.ranklist.length === 0) {
                    (async () => {
                      await getRankListAPI();
                    })();
                  }
                }}
                onBlur={focusCheck('srsRankCode', item.id)}
                errorMsg={errMsg(item.id, 'srsRankCode')}
              />
            </div>
            <div className={classes.ruleitem}>
              <div
                className={classes.dialogTitle}
                title={formatArray(
                  item.srsShiftCode?.map((el) => el.text),
                  10
                )}
              >
                {i18n.t('DUTYASSIGN_MYTEMPLATE_EDIT_SHIFT')}
              </div>
              <AutoCompleteCheckbox
                dropDownIcon={true}
                height="3.5rem"
                width="12rem"
                errMsgMargin="3px 0 0 0.825rem"
                errMsgWidth="11rem"
                placeholder={i18n.t('DUTYASSIGN_MYTEMPLATE_EDIT_SHIFT_PLACEHOLDER')}
                allText="All Shift Code"
                itemList={list.codelist}
                value={item.srsShiftCode}
                onChange={handleSelect({ id: item.id, type: 'srsShiftCode' })}
                id={`DutyAssign-AutoCompleteCheckbox-aha-${index}`}
                onOpen={() => {
                  if (list.codelist.length === 0) {
                    (async () => {
                      await getCodeAPI();
                    })();
                  }
                }}
                onBlur={focusCheck('srsShiftCode', item.id)}
                errorMsg={errMsg(item.id, 'srsShiftCode')}
              />
            </div>

            <div className={classes.ruleitem}>
              <div className={classes.dialogTitle} title={formatArray(item.rosterLeadDay?.map((el) => el?.text))}>
                {i18n.t('DUTYASSIGN_MYTEMPLATE_EDIT_ROSTER_DATE')}
              </div>
              <AutoCompleteCheckbox
                dropDownIcon={true}
                height="3.5rem"
                width="12rem"
                errMsgMargin="3px 0 0 0.825rem"
                errMsgWidth="11rem"
                placeholder={i18n.t('DUTYASSIGN_MYTEMPLATE_EDIT_ROSTER_DATE_PLACEHOLDER')}
                allText={i18n.t('DUTYASSIGN_MYTEMPLATE_EDIT_ROSTER_DATE_OPTION_ALL')}
                itemList={rosterDateList}
                value={item.rosterLeadDay}
                onChange={handleSelect({ id: item.id, type: 'rosterLeadDay' })}
                onOpen={() => {
                  if (rosterDateList.length === 0) {
                    (async () => {
                      setRosterDateList(rosterDateOptions);
                    })();
                  }
                }}
                id={`DutyAssign-AutoCompleteCheckbox-ahr-${index}`}
                onBlur={focusCheck('rosterLeadDay', item.id)}
                errorMsg={errMsg(item.id, 'rosterLeadDay')}
              />
            </div>
            <div className={classes.ruleitem}>
              <div className={classes.dialogTitle}>{i18n.t('DUTYASSIGN_ROSTER_TEMPLATE_SELECT_STAFF_TITLE')}</div>
              <IconButton
                style={{ paddingLeft: '0.8rem', paddingRight: 0 }}
                title={item.staffs.length > 0 ? item.staffs.map((el) => el.name).join('\n') : 'All Staff'}
                onClick={() => {
                  refAreaStaffSelecter.current.init();
                  refAreaStaffSelecter.current.setDialogTitle(
                    `${i18n.t('DUTYASSIGN_ROSTER_TEMPLATE_SELECT_STAFF')} : ${i18n.t(
                      'DUTYASSIGN_ROSTER_TEMPLATE_RULE'
                    )} ${index + 1}`
                  );
                  refAreaStaffSelecter.current.setOnConfirm((selectedItems) => {
                    let oldData = autoRuleData;
                    const index = _.findIndex(oldData, (autofill) => item.id === autofill.id);
                    oldData[index].staffs = selectedItems;
                    setAutoRuleData([...oldData]);
                    refAreaStaffSelecter.current.close();
                  });
                  refAreaStaffSelecter.current.setSelectedItems(item.staffs);
                  refAreaStaffSelecter.current.open();
                }}
                id="select_staff_button"
              >
                <Badge
                  badgeContent={item.staffs?.length || 'ALL'}
                  className={classes.allText}
                  color={item.staffs?.length > 0 ? 'secondary' : 'info'}
                  anchorOrigin={{ vertical: item.staffs?.length > 0 ? 'top' : 'bottom', horizontal: 'right' }}
                >
                  <Edit fontSize="small" style={{ position: 'absolute', top: -5, left: -5 }} />
                  <Group fontSize="large" />
                </Badge>
              </IconButton>
            </div>
            <ButtonBase
              style={{ marginRight: '2rem' }}
              className={classes.ruleDelete}
              onClick={handleDelete(item.id)}
              id={`DutyAssign-ButtonBase-ahb-${index}`}
            >
              <DeleteIcon className={classes.ruleDeleteIcon} />
            </ButtonBase>
          </div>
        ))}
      </div>
      <div className={classes.ruleFoot}>
        <ButtonBase className={classes.ruleAdd} onClick={handleAdd} id="DutyAssign-ButtonBase-ahc">
          <AddIcon className={classes.ruleIcon} />
          {i18n.t('DUTYASSIGN_MYTEMPLATE_EDIT_ADD_RULE')}
        </ButtonBase>
      </div>
      <AreaStaffSelecter ref={refAreaStaffSelecter} />
    </Dialog>
  );
}

function AddJTAShift({ open, setopen, allData, updateFunction }) {
  const newRow = {
    id: 1,
    rosterCode: '',
    leadTeamInfo: {},
    leadRosterInfo: {},
    staffs: [],
    isWeekday: 0,
    isDeleted: 0,
    templateFunctionalAreaId: allData.templateFunctionalAreaId,
  };
  const initData = (templateJTAMappings) => {
    const formatData = templateJTAMappings.map((item, index) => {
      return {
        ...item,
        id: index + 1,
      };
    });
    return formatData;
  };
  const classes = useStyles();
  const templateWardId = decodeQuery(window.location.search)?.id;
  const [autoRuleData, setAutoRuleData] = useState(
    allData.templateJTAMappings?.length > 0 ? initData(allData.templateJTAMappings) : [newRow]
  );
  const refAreaStaffSelecter = useRef();
  const [errorMsg, setErrorMsg] = useState({});
  const [rosterOptions, rosterOptionsSet] = useState([]);
  const [teamOptions, teamOptionsSet] = useState([]);
  const [confirmDisabled, setConfirmDisabled] = useState(true);
  const refErrorMessage = useRef(null);

  const ruleSchema = {
    leadRosterInfo: Yup.string().required(i18n.t('DUTYASSIGN_ROSTER_TEMPLATE_SELECT_ROSTER_ERROR_MSG')),
    leadTeamInfo: Yup.string().required(i18n.t('DUTYASSIGN_ROSTER_TEMPLATE_AT_LEAST_ONE_ERROR_MSG')),
  };

  useEffect(() => {
    dutyAssignAPI.getTemplateWardJTAOptions({ templateWardId }).then((res) => {
      const { result } = res;
      const { rosterJoinAreas, rosterJoinAreasOld } = result;

      const allRosterList = rosterJoinAreas
        .map((el) => ({
          text: el[0],
          value: el[0],
          group: i18n.t('DUTYASSIGN_MYTEMPLATE_EDIT_AUTO_SELECT_ROSTER_RECENTLY'),
        }))
        .concat(
          rosterJoinAreasOld.map((el) => ({
            text: el[0],
            value: el[0],
            group: i18n.t('DUTYASSIGN_MYTEMPLATE_EDIT_AUTO_SELECT_ROSTER_OLD'),
          }))
        );

      const rosterCodes = allRosterList.reduce((acc, targetObject) => {
        const isExist = acc.some(
          (item) =>
            item.text === targetObject.text && item.value === targetObject.value && item.group === targetObject.group
        );
        if (!isExist) {
          acc.push(targetObject);
        }
        return acc;
      }, []);

      rosterOptionsSet(
        rosterCodes
          .map((el) => ({ text: el.text, value: el.value, group: el.group }))
          .sort((a, b) => {
            if (a.group > b.group) return getCurrentLanguage() === 'en-us' ? -1 : 1;
            if (a.group < b.group) return getCurrentLanguage() === 'en-us' ? 1 : -1;
            return a.text.localeCompare(b.text);
          })
      );

      const allRuleList = rosterJoinAreas
        .concat(rosterJoinAreasOld)
        .map((el) => ({ text: el[1], value: el[1], roster: el[0] }));

      const allRosterJoinAreas = allRuleList.reduce((acc, targetObject) => {
        const isExist = acc.some(
          (item) =>
            item.text === targetObject.text && item.value === targetObject.value && item.roster === targetObject.roster
        );
        if (!isExist) {
          acc.push(targetObject);
        }
        return acc;
      }, []);

      teamOptionsSet(allRosterJoinAreas.sort((a, b) => a.text?.localeCompare(b.text)));
    });
  }, [templateWardId]);

  const isEmptyString = (dateString) => {
    const str = dateString?.trim();
    return str === null || str === undefined || str === '';
  };

  // useEffect(
  const checkError = useCallback(() => {
    autoRuleData.forEach(async (item) => {
      setErrorMsg((msg) => {
        return {
          ...msg,
          [item.id]: null,
        };
      });
      if (item.isDeleted === 1) {
        return;
      }
      let errInfo = {};
      if (
        isEmptyString(item.leadRosterInfo[2]) &&
        isEmptyString(item.leadTeamInfo[2]) &&
        isEmptyString(item.leadRosterInfo[1]) &&
        isEmptyString(item.leadTeamInfo[1])
      ) {
        errInfo = {
          ...errInfo,
          [item.id]: {
            ...errInfo[item.id],
            ['leadRosterInfo2']: i18n.t('DUTYASSIGN_ROSTER_TEMPLATE_SELECT_ROSTER_ERROR_MSG'),
            ['leadTeamInfo2']: i18n.t('DUTYASSIGN_ROSTER_TEMPLATE_SELECT_ROLE_ERROR_MSG'),
            ['leadRosterInfo1']: i18n.t('DUTYASSIGN_ROSTER_TEMPLATE_SELECT_ROSTER_ERROR_MSG'),
            ['leadTeamInfo1']: i18n.t('DUTYASSIGN_ROSTER_TEMPLATE_SELECT_ROLE_ERROR_MSG'),
          },
        };
      }

      // before yestoday only selected roster
      if (!isEmptyString(item.leadRosterInfo[2]) && isEmptyString(item.leadTeamInfo[2])) {
        errInfo = {
          ...errInfo,
          [item.id]: {
            ...errInfo[item.id],
            ['leadTeamInfo2']: i18n.t('DUTYASSIGN_ROSTER_TEMPLATE_SELECT_ROLE_ERROR_MSG'),
          },
        };
      }

      // before yestoday only selected role
      if (isEmptyString(item.leadRosterInfo[2]) && !isEmptyString(item.leadTeamInfo[2])) {
        errInfo = {
          ...errInfo,
          [item.id]: {
            ...errInfo[item.id],
            ['leadRosterInfo2']: i18n.t('DUTYASSIGN_ROSTER_TEMPLATE_SELECT_ROSTER_ERROR_MSG'),
          },
        };
      }

      // yestoday only selected roster
      if (!isEmptyString(item.leadRosterInfo[1]) && isEmptyString(item.leadTeamInfo[1])) {
        errInfo = {
          ...errInfo,
          [item.id]: {
            ...errInfo[item.id],
            ['leadTeamInfo1']: i18n.t('DUTYASSIGN_ROSTER_TEMPLATE_SELECT_ROLE_ERROR_MSG'),
          },
        };
      }

      // yestoday only selected role
      if (isEmptyString(item.leadRosterInfo[1]) && !isEmptyString(item.leadTeamInfo[1])) {
        errInfo = {
          ...errInfo,
          [item.id]: {
            ...errInfo[item.id],
            ['leadRosterInfo1']: i18n.t('DUTYASSIGN_ROSTER_TEMPLATE_SELECT_ROSTER_ERROR_MSG'),
          },
        };
      }
      refErrorMessage.current = {
        ...errInfo,
      };
      setErrorMsg((msg) => {
        return {
          ...msg,
          ...errInfo,
        };
      });
    });
  }, [autoRuleData]);

  useEffect(() => {
    if (errorMsg) {
      const errorKeys = Object.keys(errorMsg);
      const index = errorKeys?.findIndex((key) => {
        return errorMsg[key] !== null;
      });
      setConfirmDisabled(index !== -1);
    } else {
      setConfirmDisabled(false);
    }
  }, [errorMsg]);

  const handleAdd = useCallback(() => {
    if (autoRuleData.length === 0) {
      setAutoRuleData([newRow]);
    } else {
      const lastId = autoRuleData[autoRuleData.length - 1].id;
      setAutoRuleData(autoRuleData.concat({ ...newRow, id: lastId + 1 }));
    }
  }, [autoRuleData]);

  const errMsg = (id, type, lead) => {
    return errorMsg?.[id] && errorMsg?.[id]?.[type];
  };

  const handleSubmit = () => {
    checkError();
    if (refErrorMessage.current) {
      const errorKeys = Object.keys(refErrorMessage.current);
      const index = errorKeys?.findIndex((key) => {
        return refErrorMessage.current[key] !== null;
      });
      if (index !== -1) return;
    }
    updateFunction({
      ...allData,
      templateJTAMappings: autoRuleData.filter((el) => el.isDeleted !== 1 && el.leadRosterInfo),
    });
    setopen(false);
  };

  return (
    <Dialog
      title={i18n.t('DUTYASSIGN_ROSTER_TEMPLATE_ADD_JT_RULE')}
      cancel={i18n.t('DUTYASSIGN_CANCEL')}
      confirm={i18n.t('DUTYASSIGN_RULE_SAVE')}
      open={open}
      id="DutyAssign-Dialog-agx"
      handleOnClose={() => {
        return;
      }}
      handleClose={() => {
        setAutoRuleData(autoRuleData.map((el) => ({ isDeleted: 0, ...el })));
        setopen(false);
      }}
      handleCancel={() => {
        setAutoRuleData(autoRuleData.map((el) => ({ isDeleted: 0, ...el })));
        setopen(false);
      }}
      handleConfirm={handleSubmit}
      disabled={confirmDisabled}
      width="85rem"
    >
      <div style={{ marginBottom: '1rem' }}>
        <div className={classes.dialogTitle}>{i18n.t('DUTYASSIGN_ROSTER_TEMPLATE_SELECTED_ROLE')}</div>
        <Typography style={{ fontSize: '1.2rem' }}>{allData.functionalAreaName}</Typography>
      </div>
      <div className={classes.ruleRoot}>
        {_.filter(autoRuleData, (item) => item.isDeleted !== 1).map((item, index) => (
          <div className={classes.rulebody} key={item.id}>
            <div className={classes.ruleitem}>
              <div className={classes.dialogTitle}>
                {i18n.t('DUTYASSIGN_ROSTER_TEMPLATE_SELECT_YESTERDAY_ROSTER_TITLE')}
              </div>
              <AutoCompleteInput
                dropDownIcon={true}
                height="3.5rem"
                width="14rem"
                errMsgMargin="3px 0 0 0.825rem"
                errMsgWidth="13rem"
                placeholder={i18n.t('DUTYASSIGN_ROSTER_TEMPLATE_SELECT_ROSTER')}
                freeSolo={true}
                itemList={rosterOptions}
                value={item.leadRosterInfo[LEAD.YESTERDAY] || ''}
                onChange={(value) => {
                  let oldData = autoRuleData;
                  const index = _.findIndex(oldData, (autofill) => item.id === autofill.id);
                  let leadRosterInfo = { ...oldData[index]?.leadRosterInfo };
                  if (leadRosterInfo[LEAD.YESTERDAY] !== value) {
                    delete oldData[index].leadTeamInfo[LEAD.YESTERDAY];
                  }
                  leadRosterInfo[LEAD.YESTERDAY] = value;
                  oldData[index].leadRosterInfo = leadRosterInfo;
                  setAutoRuleData([...oldData]);
                }}
                id={`DutyAssign-AutoCompleteInput-agy2-${index}`}
                onBlur={() => checkError()}
                errorMsg={errMsg(item.id, 'leadRosterInfo1', LEAD.YESTERDAY)}
              />
            </div>
            <div className={classes.ruleitem} style={{ marginLeft: '-1rem' }}>
              <div className={classes.dialogTitle}>{i18n.t('DUTYASSIGN_ROSTER_TEMPLATE_SELECT_ROLE_TITLE')}</div>
              <AutoCompleteInput
                dropDownIcon={true}
                height="3.5rem"
                width="14rem"
                errMsgMargin="3px 0 0 0.825rem"
                errMsgWidth="13rem"
                placeholder={i18n.t('DUTYASSIGN_ROSTER_TEMPLATE_SELECT_YESTERDAY_ROLE')}
                freeSolo={true}
                allText="All Teams"
                itemList={teamOptions.filter((el) => el.value && el.roster === item.leadRosterInfo[LEAD.YESTERDAY])}
                value={item.leadTeamInfo[LEAD.YESTERDAY] || ''}
                onChange={(value) => {
                  let oldData = autoRuleData;
                  const index = _.findIndex(oldData, (autofill) => item.id === autofill.id);
                  if (value === '') {
                    delete oldData[index].leadTeamInfo[LEAD.YESTERDAY];
                  } else {
                    let leadTeamInfo = { ...oldData[index]?.leadTeamInfo };
                    leadTeamInfo[LEAD.YESTERDAY] = value;
                    oldData[index].leadTeamInfo = leadTeamInfo;
                  }
                  setAutoRuleData([...oldData]);
                }}
                id={`DutyAssign-AutoCompleteCheckbox-aha-${index}`}
                onBlur={() => checkError()}
                errorMsg={errMsg(item.id, 'leadTeamInfo1', LEAD.YESTERDAY)}
              />
            </div>
            <div className={classes.ruleitem}>
              <div className={classes.dialogTitle}>
                {i18n.t('DUTYASSIGN_ROSTER_TEMPLATE_SELECT_BEFORE_YESTERDAY_ROSTER_TITLE')}
              </div>
              <AutoCompleteInput
                dropDownIcon={true}
                height="3.5rem"
                width="14rem"
                errMsgMargin="3px 0 0 0.825rem"
                errMsgWidth="13rem"
                placeholder={i18n.t('DUTYASSIGN_ROSTER_TEMPLATE_SELECT_ROSTER')}
                freeSolo={true}
                itemList={rosterOptions}
                value={item.leadRosterInfo[LEAD.BEFORE_YESTERDAY] || ''}
                onChange={(value) => {
                  let oldData = autoRuleData;
                  const index = _.findIndex(oldData, (autofill) => item.id === autofill.id);
                  let leadRosterInfo = { ...oldData[index]?.leadRosterInfo };
                  if (leadRosterInfo[LEAD.BEFORE_YESTERDAY] !== value) {
                    delete oldData[index].leadTeamInfo[LEAD.BEFORE_YESTERDAY];
                  }
                  leadRosterInfo[LEAD.BEFORE_YESTERDAY] = value;
                  oldData[index].leadRosterInfo = leadRosterInfo;

                  setAutoRuleData([...oldData]);
                }}
                id={`DutyAssign-AutoCompleteInput-agy-${index}`}
                onBlur={() => checkError()}
                errorMsg={errMsg(item.id, 'leadRosterInfo2', LEAD.BEFORE_YESTERDAY)}
              />
            </div>
            <div className={classes.ruleitem} style={{ marginLeft: '-1rem' }}>
              <div className={classes.dialogTitle}>{i18n.t('DUTYASSIGN_ROSTER_TEMPLATE_SELECT_ROLE_TITLE')}</div>
              <AutoCompleteInput
                dropDownIcon={true}
                height="3.5rem"
                width="14rem"
                errMsgMargin="3px 0 0 0.825rem"
                errMsgWidth="13rem"
                placeholder={i18n.t('DUTYASSIGN_ROSTER_TEMPLATE_SELECT_YESTERDAY_ROLE')}
                freeSolo={true}
                allText="All Teams"
                itemList={teamOptions.filter(
                  (el) => el.value && el.roster === item.leadRosterInfo[LEAD.BEFORE_YESTERDAY]
                )}
                value={item.leadTeamInfo[LEAD.BEFORE_YESTERDAY] || ''}
                onChange={(value) => {
                  let oldData = autoRuleData;
                  const index = _.findIndex(oldData, (autofill) => item.id === autofill.id);
                  if (value === '') {
                    delete oldData[index].leadTeamInfo[LEAD.BEFORE_YESTERDAY];
                  } else {
                    let leadTeamInfo = { ...oldData[index]?.leadTeamInfo };
                    leadTeamInfo[LEAD.BEFORE_YESTERDAY] = value;
                    oldData[index].leadTeamInfo = leadTeamInfo;
                  }
                  setAutoRuleData([...oldData]);
                }}
                id={`DutyAssign-AutoCompleteCheckbox-agz-${index}`}
                onBlur={() => checkError()}
                errorMsg={errMsg(item.id, 'leadTeamInfo2', LEAD.BEFORE_YESTERDAY)}
              />
            </div>
            <div className={classes.ruleitem}>
              <div className={classes.dialogTitle}>{i18n.t('DUTYASSIGN_ROSTER_TEMPLATE_SELECT_STAFF_TITLE')}</div>
              <IconButton
                style={{ paddingLeft: '0.8rem', paddingRight: 0 }}
                title={item.staffs.length > 0 ? item.staffs.map((el) => el.name).join('\n') : 'All Staff'}
                onClick={() => {
                  refAreaStaffSelecter.current.init();
                  refAreaStaffSelecter.current.setDialogTitle(
                    `${i18n.t('DUTYASSIGN_ROSTER_TEMPLATE_SELECT_STAFF')} : ${i18n.t(
                      'DUTYASSIGN_ROSTER_TEMPLATE_RULE'
                    )} ${index + 1}`
                  );
                  refAreaStaffSelecter.current.setOnConfirm((selectedItems) => {
                    let oldData = autoRuleData;
                    const index = _.findIndex(oldData, (autofill) => item.id === autofill.id);
                    oldData[index].staffs = selectedItems;
                    setAutoRuleData([...oldData]);
                    refAreaStaffSelecter.current.close();
                  });
                  refAreaStaffSelecter.current.setSelectedItems(item.staffs);
                  refAreaStaffSelecter.current.open();
                }}
                id="select_staff_button"
              >
                <Badge
                  badgeContent={item.staffs?.length || 'ALL'}
                  className={classes.allText}
                  color={item.staffs?.length > 0 ? 'secondary' : 'info'}
                  anchorOrigin={{ vertical: item.staffs?.length > 0 ? 'top' : 'bottom', horizontal: 'right' }}
                >
                  <Edit fontSize="small" style={{ position: 'absolute', top: -5, left: -5 }} />
                  <Group fontSize="large" />
                </Badge>
              </IconButton>
            </div>
            <div className={classes.ruleitem}>
              <div className={classes.dialogTitle}>
                {i18n.t('DUTYASSIGN_ROSTER_TEMPLATE_SELECT_EFFECTIVE_DAY_TITLE')}
              </div>

              <FormControlLabel
                style={{ paddingTop: '0.325rem' }}
                className={classes.switchBase}
                control={
                  <Switch
                    checked={item.isWeekday === 1}
                    onChange={(e) => {
                      let oldData = autoRuleData;
                      const index = _.findIndex(oldData, (autofill) => item.id === autofill.id);
                      oldData[index].isWeekday = e.target.checked ? 1 : 0;
                      setAutoRuleData([...oldData]);
                    }}
                    id="effective_day_switch"
                  />
                }
                label={
                  <Typography style={{ width: '5rem' }}>
                    {item.isWeekday === 1
                      ? i18n.t('DUTYASSIGN_ROSTER_TEMPLATE_SELECT_EFFECTIVE_DAY_1_5')
                      : i18n.t('DUTYASSIGN_ROSTER_TEMPLATE_SELECT_EFFECTIVE_DAY_1_7')}
                  </Typography>
                }
                labelPlacement="end"
              />
            </div>
            <ButtonBase
              className={classes.ruleDelete}
              onClick={() => {
                let oldData = autoRuleData;
                const index = _.findIndex(oldData, (autofill) => item.id === autofill.id);
                oldData[index].isDeleted = 1;
                setAutoRuleData([...oldData]);
              }}
              id={`DutyAssign-ButtonBase-ahb-${index}`}
              style={{ paddingRight: '2rem' }}
            >
              <DeleteIcon className={classes.ruleDeleteIcon} />
            </ButtonBase>
          </div>
        ))}
      </div>
      <div className={classes.ruleFoot}>
        <ButtonBase className={classes.ruleAdd} onClick={handleAdd} id="DutyAssign-ButtonBase-ahc">
          <AddIcon className={classes.ruleIcon} />
          {i18n.t('DUTYASSIGN_MYTEMPLATE_EDIT_ADD_RULE')}
        </ButtonBase>
      </div>
      <AreaStaffSelecter ref={refAreaStaffSelecter} />
    </Dialog>
  );
}

function Rename({ open, setopen, handleRename, title, headerTitle, content }) {
  const classes = useStyles();
  const [value, setValue] = useState(title);
  const [error, setError] = useState(null);

  useEffect(() => {
    setValue(title);
  }, [title]);

  const nameSchema = {
    name: Yup.string()
      .transform((value) => value?.trim())
      .max(30, i18n.t('DUTYASSIGN_CHECK_TITLE_LENGTH', { value: 30 }))
      .required(i18n.t('DUTYASSIGN_CHECK_TITLE_MSG', { value: i18n.t('DUTYASSIGN_CHECK_TITLE') })),
  };

  const focusCheck = () => {
    return async () => {
      try {
        await checkSubmitData(Yup.object().shape(nameSchema), { name: value });
        setError(null);
      } catch (e) {
        setError({ ...e });
      }
    };
  };

  return (
    <Dialog
      title={headerTitle ?? i18n.t('DUTYASSIGN_MYTEMPLATE_EDIT_RENAME_CUBICLE')}
      cancel={i18n.t('DUTYASSIGN_CANCEL')}
      confirm={i18n.t('DUTYASSIGN_SAVE')}
      cancelID="DutyAssign-Dialog-ahd-cancel"
      confirmID="DutyAssign-Dialog-ahd-confirm"
      closeID="DutyAssign-Dialog-ahd-close"
      open={open}
      handleClose={() => {
        setopen(false);
        setValue(title);
        setError(null);
      }}
      handleCancel={() => {
        setopen(false);
        setValue(title);
        setError(null);
      }}
      handleConfirm={() => {
        if (value.length === 0 || value.length > 30) {
          (async () => {
            await focusCheck()();
          })();
          return;
        }
        handleRename(value);
        setopen(false);
      }}
      confirmStyle={{ opacity: value.length === 0 || value.length > 30 ? 0.2 : 1 }}
    >
      <div className={classes.dialogTitle}>{content ?? i18n.t('DUTYASSIGN_MYTEMPLATE_EDIT_RENAME_CUBICLE_TITLE')}</div>
      <InputBase
        className={error === null ? classes.renameInput : classNames(classes.renameInput, classes.error)}
        value={value}
        onChange={(event) => {
          setValue(event.target.value);
        }}
        id="DutyAssign-InputBase-ahe"
        onBlur={() => {
          (async () => {
            await focusCheck()();
          })();
        }}
      />
      {error && <div className={classes.errorMsg}>{error.name}</div>}
    </Dialog>
  );
}

function SetHeight({ open, setopen, height, handleSetHeight }) {
  const classes = useStyles();
  const [Height, setHeight] = useState(height === undefined ? 4 : height);
  const itemList = [
    { value: 1, text: '1' },
    { value: 2, text: '2' },
    { value: 3, text: '3' },
    { value: 4, text: '4' },
    { value: 5, text: '5' },
    { value: 6, text: '6' },
    { value: 7, text: '7' },
    { value: 8, text: '8' },
  ];

  useEffect(() => {
    setHeight(height);
  }, [height]);
  return (
    <Dialog
      title={i18n.t('DUTYASSIGN_MYTEMPLATE_EDIT_SET_HEIGHT')}
      cancel={i18n.t('DUTYASSIGN_CANCEL')}
      confirm={i18n.t('DUTYASSIGN_SAVE')}
      cancelID="DutyAssign-Dialog-ahf-cancel"
      confirmID="DutyAssign-Dialog-ahf-confirm"
      closeID="DutyAssign-Dialog-ahf-close"
      open={open}
      handleClose={() => {
        setopen(false);
      }}
      handleCancel={() => {
        setopen(false);
      }}
      handleConfirm={() => {
        handleSetHeight(Height);
        setopen(false);
      }}
    >
      <div className={classes.setHeightTitle}>{i18n.t('DUTYASSIGN_MYTEMPLATE_EDIT_SET_HEIGHT_SUBTITLE')}</div>
      <AutoCompleteSelect
        itemList={itemList}
        height="3.5rem"
        width="40.625rem"
        value={Height}
        onChange={(data) => {
          setHeight(data);
        }}
        id="DutyAssign-AutoCompleteSelect-ahg"
      />
    </Dialog>
  );
}

const List = memo(function List({
  title,
  type,
  delectListDate,
  listdate,
  setListdate,
  accept,
  index,
  triggerFunction,
  id,
  enableSmartComm,
  
}) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [addDialogOpen, setAddDialogOpen] = useState(false);
  const [addJTADialogOpen, setAddJTADialogOpen] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [renameDialogOpen, setRenameDialogOpen] = useState(false);
  const [heightDialogOpen, setHeightDialogOpen] = useState(false);
  const [openTeamDetails, setOpenTeamDetails] = useState(false);
  const refColorSelecter = useRef();
  const [anchorPosition, setAnchorPosition] = useState({ left: 0, top: 0 });
  const [selectedCardElementId, setSelectedCardElementId] = useState('');
  const [openBedStatus, setOpenBedStatus] = useState(false);
  const smartComm = enableSmartComm;
  const editData = listdate
    ? {
        title: listdate?.functionalAreaName,
        chatStartAt: listdate?.chatStartAt,
        chatEndAt: listdate?.chatEndAt,
        chatBufferEnterAt: listdate?.chatBufferEnterAt,
        chatBufferLeaveAt: listdate?.chatBufferLeaveAt,
        dutyChats: listdate?.dutyChats,
      }
    : {};

  const bedStatusData = listdate
    ? {
        bsTeamType: listdate?.bsTeamType,
        bsVisible: listdate?.bsVisible,
      }
    : {};
  const data = functionFunc.getShift(listdate);
  const ref = useRef(null);

  const handleClose = () => {
    setSelectedCardElementId('');
    setAnchorEl(null);
  };

  const handleRename = (props) => {
    setListdate({ ...listdate, functionalAreaName: props });
  };

  const handleDelete = () => {
    delectListDate();
  };

  function handleType(props) {
    const color = Boolean(props);
    if (color) {
      return classes.rootOnduty;
    }
    return classes.rootLeave;
  }

  const handleEditTeamDetails = (saveData) => {
    const newData = {
      functionalAreaName: saveData.title,
      chatStartAt: saveData.chatStartAt,
      chatEndAt: saveData.chatEndAt,
      chatBufferEnterAt: saveData.chatBufferEnterAt,
      chatBufferLeaveAt: saveData.chatBufferLeaveAt,
      dutyChats: saveData.dutyChats,
    };
    setListdate({ ...listdate, ...newData });
  };

  const handleSettingBedStatus = (saveData) => {
    const newData = {
      bsTeamType: saveData.bsTeamType,
      bsVisible: saveData.bsVisible,
    };
    setListdate({ ...listdate, ...newData });
  };
  const jtaMappingsCount = listdate.templateJTAMappings?.filter((el) => el.isDeleted !== 1).length || 0;
  const srsMappingsCount = listdate.templateMappings?.filter((el) => el.isDeleted !== 1).length || 0;
  const chatroomCount = listdate.dutyChats?.filter((el) => el.isDeleted !== 1).length || 0;

  return (
    <div
      className={handleType(type)}
      ref={ref}
      style={{
        marginLeft: index === 0 ? '0.5rem' : '0',
        backgroundColor: listdate?.bodyBackgroundColor || '#ffffff',
        opacity: `${id}-ahh` === selectedCardElementId ? 0.5 : 1,
        boxShadow:
          `${id}-ahh` !== selectedCardElementId
            ? '0 0 0.5rem 0 rgba(125, 134, 169, 0.2)'
            : '0 0 1rem 0 rgba(0, 0, 0, 1)',
      }}
    >
      <div className={classes.head}>
        <div className={classes.title} title={title}>
          {title}
        </div>
        <IconButton
          className={classes.iconBox}
          style={{ backgroundColor: listdate?.bodyBackgroundColor || '#ffffff' }}
          onClick={(event) => {
            setSelectedCardElementId(event.currentTarget.id);
            setAnchorEl(event);
            setAnchorPosition({
              top: event.clientY - event.nativeEvent?.layerY + event.currentTarget?.clientHeight * 1.2,
              left: event.clientX - event.nativeEvent?.layerX + event.currentTarget?.clientWidth * 0.7,
            });
          }}
          id={`${id}-ahh`}
        >
          <MoreIcon className={classes.icon} />
        </IconButton>
        <Menu
          className={classes.menu}
          anchorEl={anchorEl}
          open={open}
          id="DutyAssign-Menu-ahi"
          onClose={handleClose}
          keepMounted
          anchorReference="anchorPosition"
          anchorPosition={anchorPosition}
        >
          <MenuItem
            style={{ border: '0' }}
            className={classes.menuitem}
            onClick={() => {
              handleClose();
              setOpenTeamDetails(true);
            }}
            id="DutyAssign-MenuItem-ahj"
          >
            <ReNameIcon className={classes.renameIcon} style={{ marginRight: '1.4rem' }} />
            {i18n.t('DUTYASSIGN_TEAMDETAILS_TEAM_DETAILS_EDIT')}
          </MenuItem>
          <MenuItem
            className={classes.menuitem}
            onClick={() => {
              handleClose();
              setDeleteDialogOpen(true);
            }}
            id="DutyAssign-MenuItem-ahk"
          >
            <div className={classes.iconbox}>
              <DeleteIcon className={classes.Icon} />
            </div>
            {i18n.t('DUTYASSIGN_MYTEMPLATE_EDIT_CUBICLE_DELETE')}
          </MenuItem>
          <MenuItem
            className={classes.menuitem}
            onClick={() => {
              handleClose();
              setAddDialogOpen(true);
            }}
            id="DutyAssign-MenuItem-ahl"
          >
            <div className={classes.iconbox}>
              <OutstandingIcon className={classes.Icon} />
            </div>
            {i18n.t('DUTYASSIGN_MYTEMPLATE_EDIT_SRS_AUTO_RULE')}
          </MenuItem>
          <MenuItem
            className={classes.menuitem}
            onClick={() => {
              handleClose();
              setAddJTADialogOpen(true);
            }}
            id="DutyAssign-MenuItem-ahl"
          >
            <div className={classes.iconbox}>
              <OutstandingIcon className={classes.Icon} />
            </div>
            {i18n.t('DUTYASSIGN_ROSTER_TEMPLATE_ADD_JT_RULE')}
          </MenuItem>
          <MenuItem
            className={classes.menuitem}
            onClick={() => {
              handleClose();
              setHeightDialogOpen(true);
            }}
            id="DutyAssign-MenuItem-ahm"
          >
            <div className={classes.iconbox}>
              <SetHeightIcon className={classes.Icon} />
            </div>
            {i18n.t('DUTYASSIGN_LIST_SET')}
          </MenuItem>
          <MenuItem
            className={classes.menuitem}
            onClick={() => {
              handleClose();
              refColorSelecter.current.init();
              refColorSelecter.current.setDialogTitle(i18n.t('DUTYASSIGN_ROSTER_TEMPLATE_SET_BACKGROUND_COLOR'));
              refColorSelecter.current.setSubTitle(<Typography>{title}</Typography>);
              refColorSelecter.current.setSelectedColor(listdate.bodyBackgroundColor || '');
              refColorSelecter.current.setOnConfirm((selectedColor) => {
                let newData = { ...listdate };
                newData.bodyBackgroundColor = selectedColor;
                setListdate(newData);
                refColorSelecter.current.close();
              });
              refColorSelecter.current.open();
            }}
            id="DutyAssign-MenuItem-bgc"
          >
            <div className={classes.iconbox}>
              <FormatColorFill className={classes.Icon} />
            </div>
            {i18n.t('DUTYASSIGN_ROSTER_TEMPLATE_SET_BACKGROUND_COLOR')}
          </MenuItem>
          {/* <MenuItem
            className={classes.menuitem}
            onClick={() => {
              handleClose();
              setOpenBedStatus(true);
            }}
            id="DutyAssign-MenuItem-bs"
          >
            <BedStatusIcon className={classes.renameIcon} style={{ fontSize: '1rem', marginRight: '1.4rem' }} />
            {i18n.t('DUTYASSIGN_ROSTER_SETTING_BED_STATUS_TITLE')}
          </MenuItem> */}
        </Menu>
        <Delete
          open={deleteDialogOpen}
          id="DutyAssign-Delete-ahn"
          setopen={setDeleteDialogOpen}
          handleDelete={handleDelete}
        />
        {addDialogOpen ? (
          <AddShift
            open={addDialogOpen}
            id="DutyAssign-AddShift-aho"
            setopen={setAddDialogOpen}
            allData={listdate}
            updateFunction={(functionData) => {
              setListdate(functionData);
            }}
          />
        ) : (
          ''
        )}
        {addJTADialogOpen ? (
          <AddJTAShift
            open={addJTADialogOpen}
            id="DutyAssign-AddShift-aho"
            setopen={setAddJTADialogOpen}
            allData={listdate}
            updateFunction={(functionData) => {
              setListdate(functionData);
            }}
          />
        ) : (
          ''
        )}
        <Rename
          open={renameDialogOpen}
          id="DutyAssign-Rename-ahp"
          setopen={setRenameDialogOpen}
          handleRename={handleRename}
          title={title}
        />
        {openTeamDetails && (
          <TeamDetails
            closePop={() => {
              setOpenTeamDetails(false);
            }}
            open={openTeamDetails}
            title={i18n.t('DUTYASSIGN_TEAMDETAILS_TEAM_DETAILS')}
            oldData={JSON.stringify(editData)}
            confirmClick={handleEditTeamDetails}
            isTemplate={true}
            isEnableSmartComm={smartComm}
            
          />
        )}
        {openBedStatus && (
          <BedStatusSetting
            closePop={() => {
              setOpenBedStatus(false);
            }}
            open={openBedStatus}
            id="DutyAssign-setting-bed-status"
            title={i18n.t('DUTYASSIGN_ROSTER_SETTING_BED_STATUS_TITLE')}
            oldData={JSON.stringify(bedStatusData)}
            confirmClick={handleSettingBedStatus}
          />
        )}
        <SetHeight
          open={heightDialogOpen}
          setopen={setHeightDialogOpen}
          height={functionFunc.getHeight(listdate)}
          handleSetHeight={(height) => {
            setListdate(functionFunc.setHeight(listdate, height));
          }}
        />
        <ColorSelecter ref={refColorSelecter} />
      </div>
      <div style={{ marginBottom: '0.5rem' }}>
        {srsMappingsCount > 0 && <span className={classes.filledRule}>{`SRS Rule: ${srsMappingsCount}`}</span>}
        {jtaMappingsCount > 0 && <span className={classes.filledRule}>{`J/T Rule: ${jtaMappingsCount}`}</span>}
        {chatroomCount > 0 && <span className={classes.filledRule}>{`HA-Chat: ${chatroomCount}`}</span>}
      </div>
      <div className={classes.body}>
        <OnDutyCard />
        <OnDutyCard />
        <OnDutyCard />
      </div>
    </div>
  );
});

export { List, SetHeight, Delete, Rename, checkSubmitData };
